import { ROUTES } from "@/constants/routes";
import { useAuth } from "@/contexts/AuthContext";
import { RoleEnum } from "@/types";
import { Navigate, Outlet } from "react-router-dom";

export default function PublicRoute() {
  const { user, role } = useAuth();

  // Nếu đã login => vào /login sẽ redirect về home theo role
  if (user) {
    if (role === RoleEnum.OTHER) return <Navigate to={ROUTES.CHAT} replace />;
    return <Navigate to={ROUTES.E_LEARNING} replace />;
  }

  return <Outlet />; // render các page khác
}
